<ms-header
    *ngIf="showBackgroundContainer"
    [titleIcon]="titleIcon"
    [backgroundContainerConfig]="backgroundContainerConfig"
    [globalLinkConfig]="globalLinkConfig"></ms-header>

<ms-scroll-adapter size="medium" *ngIf="tiles?.length" [scrollSpeed]="scrollSpeed">
    <ul class="center" [ngClass]="getListCardClass()">
        <li class="marquee-card card card-bordered" *ngFor="let tile of tiles; trackBy: trackOutrightTile" [ngClass]="getMarqueeCardImgClass()">
            <ms-outrights-marquee-card
                [tile]="tile"
                [textColor]="backgroundContainerConfig.textColor"
                [outrightOptionGroup]="outrightOptionGroup"
                [event]="event"
                [backgroundImage]="backgroundImage"
                [globalLink]="globalLink">
            </ms-outrights-marquee-card>
        </li>
    </ul>
</ms-scroll-adapter>
